import React from "react";

const NotificationIcon = () => {
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0373 22.2408C10.5131 22.2408 7.98898 21.84 5.59481 21.0383C4.68481 20.7242 3.99148 20.085 3.68815 19.2508C3.37398 18.4167 3.48231 17.4958 3.98065 16.6725L5.22648 14.6033C5.48648 14.17 5.72481 13.3033 5.72481 12.7942V9.66333C5.72481 5.63333 9.00731 2.35083 13.0373 2.35083C17.0673 2.35083 20.3498 5.63333 20.3498 9.66333V12.7942C20.3498 13.2925 20.5881 14.17 20.8481 14.6142L22.0831 16.6725C22.549 17.4525 22.6356 18.395 22.3215 19.2508C22.0073 20.1067 21.3248 20.7567 20.469 21.0383C18.0856 21.84 15.5615 22.2408 13.0373 22.2408ZM13.0373 3.97583C9.90648 3.97583 7.34981 6.52167 7.34981 9.66333V12.7942C7.34981 13.585 7.02481 14.755 6.62398 15.4375L5.37815 17.5067C5.13981 17.9075 5.07481 18.33 5.21565 18.6875C5.34565 19.0558 5.67065 19.3375 6.11481 19.4892C10.6431 21.0058 15.4423 21.0058 19.9706 19.4892C20.3606 19.3592 20.664 19.0667 20.8048 18.6767C20.9456 18.2867 20.9131 17.8642 20.6965 17.5067L19.4506 15.4375C19.039 14.7333 18.7248 13.5742 18.7248 12.7833V9.66333C18.7248 6.52167 16.179 3.97583 13.0373 3.97583Z"
        fill="#212B36"
      />
      <path
        d="M15.0523 4.26833C14.9764 4.26833 14.9006 4.2575 14.8248 4.23583C14.5106 4.14917 14.2073 4.08417 13.9148 4.04083C12.9939 3.92167 12.1056 3.98667 11.2714 4.23583C10.9681 4.33333 10.6431 4.23583 10.4373 4.00833C10.2314 3.78083 10.1664 3.45583 10.2856 3.16333C10.7298 2.02583 11.8131 1.27833 13.0481 1.27833C14.2831 1.27833 15.3664 2.015 15.8106 3.16333C15.9189 3.45583 15.8648 3.78083 15.6589 4.00833C15.4964 4.18167 15.2689 4.26833 15.0523 4.26833Z"
        fill="#212B36"
      />
      <path
        d="M13.0374 24.7108C11.9649 24.7108 10.9249 24.2775 10.1665 23.5192C9.40819 22.7608 8.97485 21.7208 8.97485 20.6483H10.5999C10.5999 21.2875 10.8599 21.9158 11.3149 22.3708C11.7699 22.8258 12.3982 23.0858 13.0374 23.0858C14.3807 23.0858 15.4749 21.9917 15.4749 20.6483H17.0999C17.0999 22.8908 15.2799 24.7108 13.0374 24.7108Z"
        fill="#212B36"
      />
    </svg>
  );
};

export default NotificationIcon;
